<template>
    <span>
    <input :class="classes" 
    :value=displayed_value 
    v-on:change="set($event.target.value)" type="number" 
    :step="step"
    :min="parseInt(display_rounding(display_conversion(min)))"
    :max="parseInt(display_rounding(display_conversion(max)))" >
    </span>
</template>

<script>

import conversions from '../conversions.js'

export default {
    props: {
        step : {
          type: Number,
          default: 1
        },
        classes : {
          type: String,
          default: ""
        },
        min : {
          type: Number,
          default: 1
        },
        max : {
          type: Number,
          default: 100
        },
        default_value : {
          type: [Number, String],
          default: 1
        },
        store_conversion : {
          type: Function,
          default: function(val){
            //console.log("default");
            return val; // no change
          }
        },
        display_conversion: {
            type: Function,
            default: function(val){
              return val; // no change
            }
        },
        round_to_nearest: {
          type: Number,
          default: null
        }
    },
    methods : {
        set: function(val){
            //console.log("set val="+val)
            let rounded_val = this.display_rounding(val)
            //console.log("set rounded_val="+rounded_val)
            let stored_value = parseFloat(this.store_conversion(rounded_val))
            if(!isNaN(stored_value)){
                if(stored_value < this.min){
                    stored_value = this.min
                } else if(stored_value > this.max){
                    stored_value = this.max
                }
                    
                this.displayed_value = stored_value
            }
        },
        display_rounding(val){
            if(this.round_to_nearest > 0){
                let v = conversions.toNearest(val, this.round_to_nearest)
                //console.log("toNearest val="+val+" rounded="+v)
                //v = val
                if(this.step >= 1){
                    //console.log("parseInt")
                    v = parseInt(v)
                }
                //console.log(v)
                return v
            }
            if(this.step >= 1){
                //console.log("parseInt")
                val = parseInt(val)
            }
            return val
        }
    },
    computed : {
        displayed_value :{
            get() {
                let fixed = 1
                let step = ""+this.step
                if(step.split(".").length == 2){
                    fixed = step.split(".")[1].length
                }
                
                return (isNaN(this.value) ? this.display_rounding(this.display_conversion(parseFloat(this.default_value)).toFixed(fixed)) : this.value)
            },
            set(stored_value) {
                //console.log(val)
                
                if(!isNaN(stored_value)){
                    let v = this.display_rounding(stored_value)
                    this.$emit('input', v)
                    
                } else {
                    this.$emit('input', 0)
                
                }
            }
        }
    }

}
    

</script>

<style>
</style>